import {
  useLockBodyScroll
} from "./2GLSLYXR.jsx";
import {
  Button,
  ModalButton
} from "./3DBOJ4IX.jsx";
import {
  cn
} from "./O62HZC57.jsx";
import {
  useLocalization
} from "./E42DI7CC.jsx";
import {
  IconX
} from "./WHJJ2L4B.jsx";

// src/Modal/ModalBackGround.tsx
import { splitProps } from "solid-js";
import { Portal } from "solid-js/web";
var ModalBackGround = (props) => {
  const [params, rest] = splitProps(props, ["ref", "containerClass"]);
  return <Portal ref={params.ref} mount={props.mount}>
      <div
    class={cn(
      "animate-fade-in fixed inset-0 z-50 flex w-screen items-center justify-center bg-black/80 p-2 sm:p-4 md:p-10",
      params.containerClass
    )}
  >
        <div {...rest} role="dialog" />
      </div>
    </Portal>;
};

// src/Modal/BaseModal.tsx
import { mergeProps, Show } from "solid-js";
var BaseModal = (originProps) => {
  const props = mergeProps(
    {
      size: "sm"
    },
    originProps
  );
  useLockBodyScroll(() => props.visible);
  return <Show when={props.visible}>
      <ModalBackGround
    containerClass="overlay animate-fade-in fixed inset-0 z-50 flex items-center justify-center bg-black/70 py-10"
    mount={props.portal}
  >
        <div
    class={cn(
      "relative flex max-h-full flex-col overflow-hidden rounded-lg bg-white text-left shadow",
      {
        "lg:w-modal-sm w-11/12": props.size === "sm",
        "lg:w-modal-md w-11/12": props.size === "md",
        "lg:w-modal-lg w-11/12": props.size === "lg",
        "lg:w-modal-xl w-11/12": props.size === "xl",
        "w-fit": props.size === "fit"
      },
      props.class
    )}
  >
          <Show when={props.title}>
            <div
    class="border-partingline text-text-level01 relative border-b py-4 pl-6 pr-16 text-left text-lg font-semibold"
    data-slot="title"
  >
              {props.title}
              <Show when={props.showCloseButton}>
                <button
    id="base-modal-close-btn"
    class="hover:bg-inputbox-bg absolute right-6 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white p-1 duration-200 hover:rotate-180"
    type="button"
    onClick={() => props.onClose && props.onClose()}
    data-slot="close"
  >
                  <IconX class={cn("text-text-level03 size-8", props.closeBtnClass)} />
                </button>
              </Show>
            </div>
          </Show>
          <div class={cn("thinscroll flex flex-1 flex-col overflow-auto", props.contentClass)} data-slot="content">
            {props.children}
          </div>
        </div>
      </ModalBackGround>
    </Show>;
};

// src/Modal/Modal.tsx
import { createSignal, mergeProps as mergeProps2, Show as Show2 } from "solid-js";

// src/Modal/ConfirmationModal.tsx
import { Portal as Portal2 } from "solid-js/web";
var ConfirmationModal = (props) => {
  const { t } = useLocalization();
  return <Portal2>
      <div class="fixed inset-0 z-50 flex items-center justify-center">
        <div class="overlay animate-fade-in fixed inset-0 bg-black/70" onClick={() => props.onCancel()} />
        <div class="animate-zoom-in absolute flex w-4/5 flex-col gap-4 rounded-lg bg-white p-4 text-left shadow-md lg:w-96">
          <h3 class="border-b py-2 text-sm font-medium">{props.title || t("Confirmation")}</h3>
          <p class="text-text-level02 text-xs leading-5">{props.message}</p>
          <div class="flex justify-end gap-2">
            <ModalButton id="confirmation-modal-cancel-btn" type="button" onClick={() => props.onCancel()}>
              {props.cancelText || t("Go back")}
            </ModalButton>
            <ModalButton
    id="confirmation-modal-confirm-btn"
    type="button"
    class="bg-primary hover-allowed:hover:bg-primary/80 px-5 py-2 text-xs text-white"
    onClick={() => props.onConfirm()}
  >
              {props.confirmText || t("Yes")}
            </ModalButton>
          </div>
        </div>
      </div>
    </Portal2>;
};
var ConfirmationModal_default = ConfirmationModal;

// src/Modal/Modal.tsx
var Modal = (originProps) => {
  const { t } = useLocalization();
  const props = mergeProps2(
    {
      size: "md",
      doneText: t("OK"),
      cancelText: t("Cancel"),
      confirmation: {
        title: t("Confirmation"),
        message: t("Are you sure you want to cancel?"),
        cancelText: t("Go back"),
        confirmText: t("Yes")
      },
      showFooter: true
    },
    originProps
  );
  const [confirmModal, showConfirmModal] = createSignal(false);
  const handleConfirm = () => {
    showConfirmModal(false);
    props.onCancel && props.onCancel();
  };
  const handleClose = () => {
    if (props.confirmation === false) {
      props.onCancel && props.onCancel();
    } else {
      showConfirmModal(true);
    }
  };
  return <BaseModal {...props} onClose={() => handleClose()} class={props.class}>
      {props.children}
      <Show2 when={props.showFooter}>
        <Show2 when={!props.footer} fallback={props.footer}>
          <div class="border-partingline flex justify-end gap-2 border-t p-6" data-slot="footer">
            <Button id="modal-cancel-btn" class="capitalize" variant="outlined" type="button" onClick={() => handleClose()}>
              {props.cancelText}
            </Button>

            <Button
    id="modal-done-btn"
    class="capitalize"
    loading={props.loading}
    disabled={props.disabled || props.loading}
    form={props.submitId}
    color={props.doneColor}
    type={props.submitId ? "submit" : "button"}
    onClick={() => props.onDone && props.onDone()}
  >
              {props.doneText}
            </Button>
          </div>
        </Show2>
      </Show2>

      <Show2 when={confirmModal() && props.confirmation !== false}>
        <ConfirmationModal_default
    {...props.confirmation}
    onConfirm={handleConfirm}
    onCancel={() => showConfirmModal(false)}
  />
      </Show2>
    </BaseModal>;
};

// src/Modal/index.tsx
var Modal2 = Modal;
var ModalNew = Modal2;

export {
  ModalBackGround,
  BaseModal,
  Modal2 as Modal,
  ModalNew
};
